import { SalesReturnActionList, SalesReturnType } from "../../types/salesReturnTypes"
import { Action } from "../actions/types"

const initialValue: Array<SalesReturnType> = []

const salesReducer = (state: Array<SalesReturnType> = initialValue, action: Action) => {
    switch (action.type) {

        case SalesReturnActionList.ADD_SALESRETURN:
            return [
                ...state,
                action.data,
            ]

        case SalesReturnActionList.UPDATE_SALESRETURN:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case SalesReturnActionList.FETCH_SALESRETURN:
            return action.data

        case SalesReturnActionList.DELETE_SALESRETURN:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default salesReducer